import Menu from "../components/Menu";
import FooterForm from "../components/FooterForm";
export class BaseController {
    beforeRender() {
        Menu.init();
        FooterForm.init();
    }
    afterRender() {
        document.querySelector('html')?.classList.add('after-load');
    }
}
